export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;
